export const STANDALONE_PACKAGE_LOCALE_META_NAME = 'naidan-package-locale';
export const STANDALONE_PACKAGE_LOCALE_WORKER_GLOBAL_NAME = '__NAIDAN_STANDALONE_PACKAGE_LOCALE__';

// Export internal state and logic used only for testing here. Do not reference these in production logic.
// ESLint-required for TypeScript modules.
export const TEST_ONLY = {
};
